import {SubUnitsActionTypes as Actions} from "./actionTypes";
import {AppAction} from "./types";

export type CreateCustomer = () => AppAction<boolean>;

export const createCustomer = () => ({
  type: Actions.CREATE_CUSTOMER,
  payload: true
})